"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABEL_CATEGORY_KEY = 'base';
exports.LABEL_COMPONENT_KEY = 'label';